<template lang="pug">
  .gl-login.gl-layout--medium-width
    // logo
    .gl-card--logo-above
      img(v-gl-wl="{ insert: 'loginLogo' }")

    // loading: config
    gl-loading-card(:options="{ message: 'Loading application', location: 'page' }" v-if="!config")

    // form
    b-form.gl-card.gl-card--form(@submit.prevent="submitForm" v-if="config" novalidate)

      // header
      .gl-card--form__header
        .gl-card--form__header__title Sign in to your account

      // body
      .gl-card--form__body
        gl-alert(:options="{ errorList: errorList }" @clear-error-list="errorList = []")
        b-form-group(:state="form.email.state" v-gl-wl="{ apply: [ 'formLabelColor', 'formLabelFontWeight' ] }" label="Email Address" label-for="email")
          b-form-input(
            :state="form.email.state"
            v-model.trim="form.email.val"
            v-gl-focus="true"
            required
            type="text")
          .invalid-feedback(v-if="form.email.invalidFeedback") {{ form.email.invalidFeedback }}
        b-form-group(:state="form.password.state" v-gl-wl="{ apply: [ 'formLabelColor', 'formLabelFontWeight' ] }" label="Password" label-for="password")
          b-form-input(
            :state="form.password.state"
            v-model.trim="form.password.val"
            required
            type="password")
          .invalid-feedback(v-if="form.password.invalidFeedback") {{ form.password.invalidFeedback }}

      // footer
      .gl-card--form__footer
        gl-btn(:options="{ label: 'Sign In', size: 'full-width', type: 'submit', style: 'brand', isLoading: isLoading.submitForm }")
        router-link.gl-card--form__footer__link(:to="{ name: 'forgot-password' }" v-gl-wl="{ apply: 'linkColor' }") Forgot your password?
</template>

<script>
import { mapGetters } from 'vuex'

export default {

  // computed
  computed: {
    ...mapGetters(['config'])
  },

  // data
  data () {
    return {
      errorList: [],
      form: {
        email: { val: '', state: null, invalidFeedback: '' },
        password: { val: '', state: null, invalidFeedback: '' }
      },
      isLoading: {
        submitForm: false
      }
    }
  },

  // methods
  methods: {
    submitForm () {
      // clear previous errors
      this.errorList = []

      // clear previous feedback
      this.$glForm.clearFeedback(this.form)

      // if form is valid
      if (this.validateForm()) {
        // start loading
        this.isLoading.submitForm = true

        // login
        return this.$glAuth.login(this.$glForm.getVals(this.form))
          .then(() => {
            // navigate to the dashboard
            this.$router.push('dashboard')
          })
          .catch(e => {
            // push server error
            this.errorList.push(this.$glForm.parseError(e))
          })
          .finally(() => {
            // stop loading
            this.isLoading.submitForm = false
          })
      } else {
        // focus first error
        this.$glForm.focusFirstError({ el: this.$el })
      }
    },
    validateForm () {
      // if no email -> invalid
      if (!this.form.email.val) {
        this.form.email.state = 'invalid'
        this.form.email.invalidFeedback = 'An email address is required'
      }
      // if email does not have an @ -> invalid
      if (this.form.email.val && !this.form.email.val.match(/\S+@\S+/)) {
        this.form.email.state = 'invalid'
        this.form.email.invalidFeedback = 'A valid email address is required'
      }
      // if no password -> invalid
      if (!this.form.password.val) {
        this.form.password.state = 'invalid'
        this.form.password.invalidFeedback = 'A password is required'
      }

      // return true if no fields are invalid
      return this.$glForm.hasNoInvalid(this.form)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/Login.vue